import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { CheckCircle, XCircle, AlertCircle, Info, X } from 'lucide-react';

const Toast = ({ message, type = 'success', onClose, duration = 3000 }) => {
  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  const icons = {
    success: <CheckCircle className="w-5 h-5 text-primary" />,
    error: <XCircle className="w-5 h-5 text-red-400" />,
    warning: <AlertCircle className="w-5 h-5 text-yellow-400" />,
    info: <Info className="w-5 h-5 text-blue-400" />,
  };

  const bgColors = {
    success: 'bg-primary/10 border-primary/30',
    error: 'bg-red-500/10 border-red-500/30',
    warning: 'bg-yellow-500/10 border-yellow-500/30',
    info: 'bg-blue-500/10 border-blue-500/30',
  };

  const textColors = {
    success: 'text-primary',
    error: 'text-red-400',
    warning: 'text-yellow-400',
    info: 'text-blue-400',
  };

  const toastContent = (
    <div
      className={`fixed top-4 right-4 z-[99999] flex items-center gap-3 px-4 py-3 rounded-lg border bg-card/95 backdrop-blur-md shadow-xl animate-slide-in-right ${bgColors[type]}`}
      role="alert"
      style={{ 
        zIndex: 99999,
        pointerEvents: 'auto'
      }}
    >
      <div className="flex-shrink-0">
        {icons[type]}
      </div>
      <p className={`text-sm font-medium ${textColors[type]}`}>
        {message}
      </p>
      <button
        onClick={onClose}
        className="ml-2 flex-shrink-0 p-1 hover:bg-black/10 rounded transition-colors"
        aria-label="Close"
      >
        <X className="w-4 h-4 text-muted-foreground" />
      </button>
    </div>
  );

  // Render toast using portal to ensure it's above all modals
  if (typeof window !== 'undefined') {
    return createPortal(toastContent, document.body);
  }
  
  return toastContent;
};

export default Toast;

